import Route from "../../../router/Route";
import { RouterView } from "vue-router";

import BasePriceIndex from "../pages/BasePriceIndex.vue";
import BasePricePlanEditor from "../pages/BasePricePlanEditor.vue";
import BasePriceBrutoPlanEditor from "../pages/BasePriceBrutoPlanEditor.vue";

export default new Route("base_prices", "/base-prices", RouterView, [
	new Route("base_price.index", "", BasePriceIndex, [], {
		permissions: ["can_manage_base_prices"],
	}),
	new Route("base_price.edit", ":plan_uuid/edit", BasePricePlanEditor, [], {
		permissions: ["can_manage_base_prices"],
	}),
	new Route(
		"base_price.bruto.edit",
		":plan_uuid/bruto",
		BasePriceBrutoPlanEditor,
		[],
		{ permissions: ["can_manage_base_prices"] }
	),
]);
